<template>
  <table class="table table-striped items" v-if="items && items.length > 0">
    <thead>
    <tr>
      <th>Beschrijving</th>
      <th>Totaal</th>
      <th>Totaal commissie</th>
      <th>
<!--        <button type="button" @click="addItem" class="btn btn-secondary">+</button>-->
      </th>
    </tr>
    </thead>

    <tbody>
    <InvoiceItem
      v-for="(item, index) in items"
      :item="item"
      :index="index"
      :key="item.id"
      @remove-item="removeItem"
      @update-item="(item) => updateItem(index, item)"
      @add-item="addItem(index)"
    />
    </tbody>
  </table>
</template>

<script setup>
import {defineProps, reactive, defineEmits, computed, watch} from "vue";
import InvoiceItem from "./InvoiceItem.vue";

const {items} = defineProps(["items"]);

const emit = defineEmits(["add-item", "update-items", "add-item"]);

const addItem = (index) => {
  emit("add-item", index);
};

const removeItem = (index) => {
  items.splice(index, 1);
  emit("update-items", items);
};

const updateItem = (index, item) => {
  items.splice(index, 1, item);
  emit("update-items", items);
}
</script>

<style scoped>
.items tbody >>> tr:nth-child(2n) {
  border-bottom: 2px solid darkgray;
}
</style>
